import gql from 'graphql-tag'

export const completeOpportunity = gql`
  mutation CompleteOpportunity($id: String!) {
    completeOpportunity(id: $id) {
      opportunity {
        id
        state
      }
      errors {
        key
        message
      }
    }
  }
`
